import { z } from 'zod/v4'
import { WorkflowNodeBaseSchema } from '../../../resources/types'

// Input validation schema
const ContactCreateInputsSchema = z.object({
  name: z.string().describe('Contact name'),
  channel: z
    .object({
      'communication-channel-id': z
        .string()
        .describe('The ID of the communication channel'),
      'identifier-value': z
        .string()
        .describe('The identifier value on this channel (email, phone, etc.)'),
    })
    .optional()
    .describe('Channel subscription details'),
  associations: z
    .array(
      z.object({
        'instance-id': z.string().describe('The instance ID to associate'),
      }),
    )
    .optional()
    .describe('CRM instances to associate with this contact'),
})

// Contact service options
const ContactCreateOptionsSchema = z.object({
  // Add any contact-specific options here
})

// Export the command schema
export const ContactCreateCommandSchema = WorkflowNodeBaseSchema.extend({
  service: z.object({
    name: z.literal('skedyul/conversations'),
    cmd: z.literal('contact.create'),
    options: ContactCreateOptionsSchema.optional(),
  }),
  inputs: ContactCreateInputsSchema,
})

export type ContactCreateCommand = z.infer<typeof ContactCreateCommandSchema>
